// 서비스 03 DESIGN & CONSTRUCTION 가로 아코디언
// 패널에 마우스를 올리면(또는 클릭/포커스) 해당 패널만 .is-active 로 펼쳐진다.
export function initServiceAccordion({
  root = ".service-accordion",
  panelSel = ".service-accordion__panel",
} = {}) {
  const accordions = document.querySelectorAll(root);
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    const panels = [...accordion.querySelectorAll(panelSel)];
    if (!panels.length) return;

    const activate = (target) => {
      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel === target);
      });
    };

    // 최초 활성 패널 보장 (마크업에 없으면 첫 패널)
    if (!panels.some((panel) => panel.classList.contains("is-active"))) {
      activate(panels[0]);
    }

    panels.forEach((panel) => {
      panel.addEventListener("mouseenter", () => activate(panel));
      panel.addEventListener("focusin", () => activate(panel));
      panel.addEventListener("click", () => activate(panel));
    });
  });
}
